import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const InstagramCallback = () => {
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');

        if (token) {
            try {
                // Decode token to get some basic user info for the UI
                const payload = JSON.parse(atob(token.split('.')[1]));
                const userData = {
                    id: payload.id,
                    username: payload.username,
                    role: payload.role
                };

                login(userData, token);
                navigate('/home');
            } catch (error) {
                console.error('Failed to process login token:', error);
                navigate('/login?error=token_invalid');
            }
        } else {
            console.error('No token found in callback URL');
            navigate('/login?error=no_token');
        }
    }, [location, login, navigate]);

    return (
        <div style={{
            display: 'flex',
            height: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#000',
            color: '#fff',
            flexDirection: 'column',
            gap: '20px'
        }}>
            <div className="loader" style={{
                border: '4px solid rgba(255, 255, 255, 0.1)',
                borderTop: '4px solid #cc2366',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                animation: 'spin 1s linear infinite'
            }} />
            <p>Autenticando com Instagram...</p>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default InstagramCallback;
